// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoSuggestionsPanel_SP_root__AG9Pd","title":"VideoSuggestionsPanel_SP_title__1mNrl","list":"VideoSuggestionsPanel_SP_list__ApBww"};